/*
 *  REST Service object: TrackerRest
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { doGetPromise } from '../../../core/config/core.httpclient-utils';
@Injectable()
export class TrackeritemRest {

    constructor(private http: HttpClient) {
        this.http = http;
    }

    save(trackerItemId: number = 0, trackerItemData: any = {}) {
        return this.http.post(`/api/trackeritem/${trackerItemId}`, trackerItemData)
            .toPromise();
    }

    move(trackerItemId: number = 0, trackerItemData: any = {}) {
        return this.http.post(`/api/trackeritem/${trackerItemId}/move`, trackerItemData)
            .toPromise();
    }

    clone(trackerItemId: number = 0, cloneData: any = {}) {
        return this.http.post(`/api/trackeritem/${trackerItemId}/clone`, cloneData)
            .toPromise();
    }

    fetch(trackerItemId: number = 0, params: any = {}) {
        if (trackerItemId > 0) {
            return doGetPromise(this.http, `/api/trackeritem/${trackerItemId}`, params);
        } else {
            return doGetPromise(this.http, '/api/trackeritem', params);
        }
    }
    
    delete(trackerItemId: number = 0, ids: string = '') {
        let idList = ids?.length > 0 ? '?idList=' + ids : '';
        return this.http.delete(`/api/trackeritem/${trackerItemId}/${idList}`)
        .toPromise(); 
    }
  
    getDetails(trackerItemId: number = 0, queryData: any = {}) {
        return doGetPromise(this.http, `/api/trackeritem/${trackerItemId}/details/`, queryData);
    }

    getMergeStatus(trackerItemId: number = 0) {
        return doGetPromise(this.http, `/api/trackeritem/${trackerItemId}/details/?rel=merge_status`);
    }

    postMultiple(trkackerItems: any = []) {
        return this.http.post(`/api/trackeritem/0/multi`, trkackerItems)
        .toPromise();
    }

    postAttachment(trackerItemId: number = 0, attachmentId: number = 0, data: any = {}) {
        return this.http.post(`/api/trackeritem/${trackerItemId}/attachment/${attachmentId}`, data)
        .toPromise();
    }

    deleteAttachment(trackerItemId: number = 0, attachmentId: number = 0) {
        return this.http.delete(`/api/trackeritem/${trackerItemId}/attachment/${attachmentId}`)
        .toPromise(); 
    }

    postReaction(trackerItemId: number = 0, messageId: number = 0, data: any = {}) {
        return this.http.post(`/api/trackeritem/${trackerItemId}/reaction/${messageId}`, data)
        .toPromise();
    }

    postDuplicate(trackerItemId: number = 0, data: any = {}) {
        return this.http.post(`/api/trackeritem/${trackerItemId}/duplicate`, data)
        .toPromise();
    }

    deleteDuplicate(trackerItemId: number = 0, duplicateOfTid: number = 0) {
        return this.http.delete(`/api/trackeritem/${trackerItemId}/duplicate/${duplicateOfTid}`)
        .toPromise();
    }

    postFollowup(trackerItemId: number = 0, followupId: number = 0, data: any = {}) {
        return this.http.post(`/api/trackeritem/${trackerItemId}/followup/${followupId}`, data)
        .toPromise();
    }

    deleteFollowup(trackerItemId: number = 0, followupId: number = 0) {
        return this.http.delete(`/api/trackeritem/${trackerItemId}/followup/${followupId}`)
        .toPromise();
    }

    getBranches(trackerItemId: number = 0) {
        return doGetPromise(this.http, `/api/trackeritem/${trackerItemId}/branches`);
    }

    postEvent(trackerItemId: number, payload: object): Promise<any> {
        return this.http.post(`/api/trackeritem/${trackerItemId}/event`, payload)
            .toPromise();
    }
}
